/* eslint-disable react/require-default-props */
import React, { useCallback } from 'react';
import { Lightbox } from 'yet-another-react-lightbox';
import Video from 'yet-another-react-lightbox/plugins/video';
import 'yet-another-react-lightbox/styles.css';
import './PhotoCarouselStyles.scss';
/**
 * PhotoCarousel
 * Lightbox carousel wrapping yet-another-react-lightbox with Quimby `qmb-media` chrome.
 * Finite (no wrap-around). Close is the only built-in toolbar button.
 *
 * @version 1.0.0
 * @since 2026-08-26
 */
export function PhotoCarousel({ open, index, slides, onClose, onIndexChange, className = '' }) {
    const handleView = useCallback(({ index: nextIndex }) => {
        onIndexChange === null || onIndexChange === void 0 ? void 0 : onIndexChange(nextIndex);
    }, [onIndexChange]);
    // `document` slides are ours, not a yarl plugin's: the library has no document renderer, and
    // returning `undefined` for everything else lets image/video fall through to its own handling.
    // Deliberately a plain `<object>` (the browser's native viewer, with print/download/page nav)
    // rather than `PDFViewer` — importing that here would pull react-pdf into every carousel
    // consumer, including the buildings/inspections/work-order photo galleries.
    // `react/no-unused-prop-types` reads this yarl render callback as a component — it destructures
    // a prop and returns JSX — and so misses that `slide` is used on the very next line.
    // eslint-disable-next-line react/no-unused-prop-types
    const renderSlide = useCallback(({ slide }) => {
        var _a;
        if (slide.type !== 'document')
            return undefined;
        const doc = slide;
        return (React.createElement("object", { data: doc.src, type: "application/pdf", className: "qmb-ui-photo-carousel__document", "aria-label": doc.alt },
            React.createElement("p", null,
                React.createElement("a", { href: doc.src, target: "_blank", rel: "noopener noreferrer" }, (_a = doc.alt) !== null && _a !== void 0 ? _a : 'Open document'))));
    }, []);
    if (!open)
        return null;
    const rootClass = ['qmb-ui-photo-carousel', 'qmb-media', className].filter(Boolean).join(' ');
    return (React.createElement(Lightbox, { carousel: { finite: true }, open: open, index: index, close: onClose, slides: slides, plugins: [Video], className: rootClass, on: { view: handleView }, render: { slide: renderSlide }, toolbar: { buttons: ['close'] } }));
}
PhotoCarousel.displayName = 'PhotoCarousel';
